module.exports = __webpack_public_path__ + "media/images/flags/16/Faroes-dd22b2056dc208b5c8ddb040ff1e8c2f.png";